import app from '../app';
import Page, { IPageAttrs } from '../../common/components/Page';
import type Mithril from 'mithril';
import NotificationListState from '../states/NotificationListState';
import { PowerGlitch, GlitchResult, PlayModes } from 'powerglitch';
import Button from '../../common/components/Button';
import LogInModal from '../../forum/components/LogInModal';
import PuzzleRoleBindingModal from '../../forum/dianLiang/PuzzleRoleBindingModal';
import PuzzleBadgeModal from '../../forum/dianLiang/PuzzleBadgeModal';

export default class PuzzlePage<CustomAttrs extends IPageAttrs = IPageAttrs> extends Page<CustomAttrs> {
  // 徽章元素
  protected imgs = [
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-yq.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-yq1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-yoq.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-yoq1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-cs.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-cs1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-ax.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-ax1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-zs.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-zs1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-cz.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-cz1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-xw.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-xw1.webp`,
    },
    {
      src: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-gm.webp`,
      src2: `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/hz-gm1.webp`,
    },
  ];
  // 完成的背景
  protected completeBgs = {
    pc: [
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-1.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-2.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-3.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-4.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-5.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-6.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-7.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/jy-8.webp`,
    ],
    phone: [
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-1.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-2.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-3.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-4.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-5.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-6.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-7.webp`,
      `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/jy-8.webp`,
    ],
  };
  // 完成的背景位置
  protected pos = {
    pc: [
      { x: 0, y: 0 },
      { x: 454, y: 0 },
      { x: 225, y: 237 },
      { x: 661, y: 160 },
      { x: 103, y: 300 },
      { x: 751, y: 341 },
      { x: 228, y: 361 },
      { x: 477, y: 404 },
    ],
    phone: [
      { x: 0, y: 5 },
      { x: 42, y: 21 },
      { x: 0, y: 43 },
      { x: 40, y: 49 },
      { x: 0, y: 84 },
      { x: 43, y: 72 },
      { x: 0, y: 99 },
      { x: 40, y: 114 },
    ],
  };
  // 遮罩图片大小
  protected possize = {
    pc: [
      { w: 540, h: 347 },
      { w: 430, h: 500 },
      { w: 493, h: 353 },
      { w: 521, h: 343 },
      { w: 318, h: 287 },
      { w: 530, h: 290 },
      { w: 316, h: 388 },
      { w: 430, h: 354 },
    ],
    phone: [
      { w: 55, h: 50 },
      { w: 58, h: 47 },
      { w: 55, h: 62 },
      { w: 60, h: 50 },
      { w: 52, h: 51 },
      { w: 57, h: 60 },
      { w: 55, h: 57 },
      { w: 60, h: 58 },
    ],
  };
  protected controller1: GlitchResult | null = null;
  protected controller2: GlitchResult | null = null;
  protected controller3: GlitchResult | null = null;
  protected controller4: GlitchResult | null = null;
  protected controller5: GlitchResult | null = null;
  protected controller6: GlitchResult | null = null;
  protected controller7: GlitchResult | null = null;
  protected controller8: GlitchResult | null = null;
  protected items: NodeListOf<Element> | null = null;
  // 滑动参数
  protected currentPosition = 0;
  protected startX = 0;
  protected startY = 0;
  protected isDragging = false;
  protected threshold = 50; // 滑动阈值，超过这个距离才触发移动
  protected itemCount = 0;
  // 椭圆参数
  protected radiusX = 600;
  protected radiusY = 300;
  // 计算八个固定点的位置
  protected positions = [{}];
  // 转动序列和状态
  protected targetSequence = [
    { direction: 'reverse' as const, count: 2 },
    { direction: 'forward' as const, count: 3 },
    { direction: 'forward' as const, count: 1 },
    { direction: 'reverse' as const, count: 1 },
    { direction: 'reverse' as const, count: 2 },
    { direction: 'reverse' as const, count: 5 },
    { direction: 'forward' as const, count: 3 },
    { direction: 'forward' as const, count: 1 },
  ];
  protected currentStepIndex: number = 0;
  protected currentStepCount: number = 0;
  // 添加序数词映射
  protected ordinalWords = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'];
  protected lightList = [0, 0, 0, 0, 0, 0, 0, 0];
  // 诚实徽章答案显示
  protected csanswer = false;
  protected PCstyle = true;
  protected guessGameInfo = {};
  protected sendCounts = 31;
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    this.discussionId = app.forum.attribute('guessGameDiscussionId');
    
    app.store.find('discussions', this.discussionId).then(() => {
      m.redraw();
    });
     
    if (window.innerWidth < 768) {
      this.PCstyle = false;
    }
    app.notifications = new NotificationListState({
      filter: { type: ['postPuzzleed'] },
      // sort: 'newest',
    });
    const appNavigation = document.getElementById('app-navigation');
    appNavigation.style.display = 'none';
    app.notifications.load();
    ['.App', '.App-content'].forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.paddingBottom = '0';
        element.style.paddingTop = '0';
      });
    });
    if (window.innerWidth < 768) {
      this.radiusX = (window.innerWidth - window.innerWidth * 0.4) / 2;
      this.radiusY = this.radiusX * 2;
    }
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/guessGame',
      })
      .then((res) => {
        if (res && res?.data) {
          app.data['GuessGameRole'] = res?.data;
          m.redraw();
        }
      });
    if (!this.attrs.isOpen) {
      app.modal.show(PuzzleRoleBindingModal);
    }
  }
  onremove(vnode: Mithril.VnodeDOM<CustomAttrs, this>): void {
    super.onremove(vnode);
    const appNavigation = document.getElementById('app-navigation');
    appNavigation.style.display = 'block';
    ['.App', '.App-content'].forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('padding-top');
      });
    });
    app.modal.close();
  }
  oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>): void {
    const glitchOptions = {
      playMode: 'always' as PlayModes,
      createContainers: true,
      hideOverflow: false,
      timing: {
        duration: 3000,
        iterations: Infinity,
      },
      glitchTimeSpan: {
        start: 0.4,
        end: 0.6,
      },
      shake: {
        velocity: 15,
        amplitudeX: 0.2,
        amplitudeY: 0.2,
      },
      slice: {
        count: 8,
        velocity: 25,
        minHeight: 0.02,
        maxHeight: 0.15,
        hueRotate: true,
      },
    };
    this.controller1 = PowerGlitch.glitch('#glitch1', glitchOptions);
    this.controller2 = PowerGlitch.glitch('#glitch2', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0,
        end: 0.2,
      },
    });
    this.controller3 = PowerGlitch.glitch('#glitch3', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.7,
        end: 0.9,
      },
    });
    this.controller4 = PowerGlitch.glitch('#glitch4', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.3,
        end: 0.5,
      },
    });
    this.controller5 = PowerGlitch.glitch('#glitch5', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.6,
        end: 0.8,
      },
    });
    this.controller6 = PowerGlitch.glitch('#glitch6', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.2,
        end: 0.4,
      },
    });
    this.controller7 = PowerGlitch.glitch('#glitch7', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.1,
        end: 0.3,
      },
    });
    this.controller8 = PowerGlitch.glitch('#glitch8', {
      ...glitchOptions,
      glitchTimeSpan: {
        start: 0.8,
        end: 1,
      },
    });
    const container = document.querySelector('.glitch-container');
    this.items = document.querySelectorAll('.glitch-item');
    this.itemCount = this.items.length;
    const rotationOffset = Math.PI / 8;
    this.positions = Array.from({ length: this.itemCount }, (_, i) => {
      const angle = (i * 2 * Math.PI) / this.itemCount + rotationOffset;
      return {
        x: Math.cos(angle) * this.radiusX,
        y: Math.sin(angle) * this.radiusY,
      };
    });
    // 鼠标事件
    container?.addEventListener('mousedown', (e) => {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      e.preventDefault();
    });
    document.addEventListener('mousemove', (e) => {
      if (!this.isDragging) return;
      e.preventDefault();
    });

    document.addEventListener('mouseup', (e) => {
      if (!this.isDragging) return;

      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;

      // 判断滑动方向
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.threshold) {
        this.updateItems(deltaX > 0 ? -1 : 1);
      }

      this.isDragging = false;
      e.preventDefault();
    });

    // 触摸事件
    container?.addEventListener('touchstart', (e) => {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    });

    document.addEventListener('touchmove', (e) => {
      if (!this.isDragging) return;
      e.preventDefault();
    });

    document.addEventListener('touchend', (e) => {
      if (!this.isDragging) return;

      const deltaX = e.changedTouches[0].clientX - this.startX;
      const deltaY = e.changedTouches[0].clientY - this.startY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.threshold) {
        this.updateItems(deltaX > 0 ? -1 : 1);
      }

      this.isDragging = false;
    });
  }

  view() {
    let roleAttributes;
    let discussion = app.store.getById('discussions', this.discussionId);
    app.data['guessGameInfo'] = discussion?.guessGameInfo();
    if (app.data['guessGameInfo']) {
      this.guessGameInfo  = JSON.parse(app.data['guessGameInfo']);
      this.sendCounts = this.guessGameInfo?.sendCounts;
      roleAttributes = this.guessGameInfo;
      if (this.guessGameInfo?.badge_one_isLight) {
        this.controller1?.stopGlitch();
        this.lightList[0] = 1;
      }
      if (this.guessGameInfo?.badge_two_isLight) {
        this.controller2?.stopGlitch();
        this.lightList[1] = 1;
      }
      if (this.guessGameInfo?.badge_three_isLight) {
        this.controller3?.stopGlitch();
        this.lightList[2] = 1;
      }
      if (this.guessGameInfo?.badge_four_isLight) {
        this.controller4?.stopGlitch();
        this.lightList[3] = 1;
      }
      if (this.guessGameInfo?.badge_five_isLight) {
        this.lightList[4] = 1;
        this.controller5?.stopGlitch();
      }
      if (this.guessGameInfo?.badge_six_isLight) {
        this.lightList[5] = 1;
        this.controller6?.stopGlitch();
      }
      if (this.guessGameInfo?.badge_seven_isLight) {
        this.lightList[6] = 1;
        this.controller7?.stopGlitch();
      }
      if (this.guessGameInfo?.badge_eight_isLight) {
        this.lightList[7] = 1;
        this.controller8?.stopGlitch();
      }
    }
    // 生成过滤条件
    const shouldShow = (index: number) => {
      if (!roleAttributes) return false;

      const propName = `badge_${this.ordinalWords[index]}_isLight` as keyof typeof roleAttributes;
      return roleAttributes[propName];
    };
    // 过滤数组
    const filteredCompleteBgs = this.completeBgs[this.PCstyle ? 'pc' : 'phone'].filter((_, index) => shouldShow(index));
    const filteredPos = this.pos[this.PCstyle ? 'pc' : 'phone'].filter((_, index) => shouldShow(index));
    const filteredPossize = this.possize[this.PCstyle ? 'pc' : 'phone'].filter((_, index) => shouldShow(index));
    return (
      <div className="PuzzlePage">
        <div className="glitch-container">
          {this.imgs.map((img, index) => {
            return (
              <div className="glitch-item" data-index={index}>
                <img
                  className="glitch-image"
                  id={`glitch${index + 1}`}
                  src={this.lightList[index] ? img.src2 : img.src}
                  alt="Glitch Effect"
                  onclick={() => this.stopGlitch(img, index)}
                />
              </div>
            );
          })}
          <div
            className={`complete-container ${this.lightList.filter((item) => item === 1).length === 8 ? 'puzzle-complete' : ''}`}
            style={{
              opacity: filteredCompleteBgs.length > 0 ? 1 : 0, // 数据未准备好时完全透明
              transition: 'opacity 0.2s linear',
            }}
          >
            {/* 第一张图片 */}
            <img
              className="complete-container-image"
              style={{
                position: 'absolute',
                opacity: this.lightList.filter((item) => item === 1).length === 8 ? 1 : 0,
                transition: 'opacity 1s ease-in-out', // 添加过渡效果
              }}
              src={
                this.PCstyle
                  ? `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/bg-ren2.webp`
                  : `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/bg-ren2.webp`
              }
            />

            {/* 第二张图片 */}
            <img
              className="complete-container-image"
              style={{
                position: 'absolute',
                opacity: this.lightList.filter((item) => item === 1).length === 8 ? 0 : 1,
                transition: 'opacity 1s ease-in-out', // 添加过渡效果
                maskImage: filteredCompleteBgs.map((bg) => `url(${bg})`).join(', '),
                '-webkit-mask-image':filteredCompleteBgs.map((bg) => `url(${bg})`).join(', '),
                maskPosition: filteredPos.map((p) => (this.PCstyle ? `${p.x}px ${p.y}px` : `${p.x}vw ${p.y}vw`)).join(', '),
                '-webkit-mask-position': filteredPos.map((p) => (this.PCstyle ? `${p.x}px ${p.y}px` : `${p.x}vw ${p.y}vw`)).join(', '),
                maskSize: filteredPossize.map((p) => (this.PCstyle ? `${p.w}px ${p.h}px` : `${p.w}vw ${p.h}vw`)).join(', '),
                '-webkit-mask-size': filteredPossize.map((p) => (this.PCstyle ? `${p.w}px ${p.h}px` : `${p.w}vw ${p.h}vw`)).join(', '),
                maskRepeat: 'no-repeat',
                '-webkit-mask-repeat': 'no-repeat',
              }}
              src={
                this.PCstyle
                  ? `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexpc/bg-ren.webp`
                  : `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameindexmodile/bg-ren.webp`
              }
            />
          </div>
        </div>
        <div class="user-info">
          {/* <Button className="login-btn" onclick={()=>app.modal.show(PuzzleRoleBindingModal)}>
            角色
          </Button> */}
          {app.data['GuessGameRole'] ? (
            <div className="user-role-info" onclick={() => !app.data['GuessGameRole'] && app.modal.show(PuzzleRoleBindingModal)}>
              <div>{app.data['GuessGameRole']?.attributes.roleName}</div>
              <div>
                {app.translator.trans('dl_setGuessGame.forum.puzzlePage.srvId')}:{app.data['GuessGameRole']?.attributes.srvId}
              </div>
            </div>
          ) : (
            <div className="user-role-info" onclick={() => !app.data['GuessGameRole'] && app.modal.show(PuzzleRoleBindingModal)}>
              <div>{app.translator.trans('dl_setGuessGame.forum.puzzlePage.please_bind_role')}</div>
            </div>
          )}
          {!app.session.user ? (
            <Button className="login-btn" onclick={() => app.modal.show(LogInModal)}>
              {app.translator.trans('dl_setGuessGame.forum.puzzlePage.login_btn')}
            </Button>
          ) : (
            <Button className="login-btn" onclick={() => this.onLogOff()}>
              {app.translator.trans('dl_setGuessGame.forum.puzzlePage.logout_btn')}
            </Button>
          )}
        </div>
        {this.csanswer && (
          <div className="csanswer">
            <div className="csanswer-title">send "my friend,thanks" to {this.sendCounts} players</div>
          </div>
        )}
        {app.data['GuessGameRole'] && (
          <div class="scan-container">
            <div class="scan-line"></div>
          </div>
        )}
      </div>
    );
  }
  stopGlitch(img: any, index: number) {
    // controller?.stopGlitch();
    if (!app.data['GuessGameRole']) {
      app.modal.show(PuzzleRoleBindingModal);
      return;
    }
    app.modal.show(PuzzleBadgeModal, { img: img, index });
  }
  updateItems(direction: any) {
    this.currentPosition = (this.currentPosition + direction + this.itemCount) % this.itemCount;

    this.items?.forEach((item, index) => {
      const targetIndex = (index + this.currentPosition) % this.itemCount;
      const pos = this.positions[targetIndex];
      item.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      item.setAttribute('data-index', targetIndex.toString());
    });
    // 转动序列检测逻辑
    const currentDirection = direction === 1 ? 'forward' : 'reverse';
    const currentStep = this.targetSequence[this.currentStepIndex];

    if (currentStep && currentDirection === currentStep.direction) {
      this.currentStepCount++;
      if (this.currentStepCount === currentStep.count) {
        this.currentStepIndex++;
        this.currentStepCount = 0;
        if (this.currentStepIndex === this.targetSequence.length) {
          this.csanswer = true;
          this.currentStepIndex = 0;
          this.currentStepCount = 0;
          m.redraw()
        }
      }
    } else {
      this.currentStepIndex = 0;
      this.currentStepCount = 0;
    }
  }
  onLogOff() {
    if (
      confirm(
        app.translator.trans('dl_setGuessGame.forum.puzzlePage.confirm_logout') +
          '\n' +
          app.translator.trans('dl_setGuessGame.forum.puzzlePage.use_game_account_login')
      )
    ) {
      app.session.logout();
    }
  }
}
